/*
 * @copyright Copyright (c) 2019 Julius Härtl <jus@bitgrid.net>
 *
 * @author Julius Härtl <jus@bitgrid.net>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
var ConfigService = /** @class */ (function () {
    function ConfigService() {
        this.values = {};
        this.loadFromGlobal('userId');
        this.loadFromGlobal('urlsrc');
        this.loadFromGlobal('directEdit');
        this.loadFromGlobal('directGuest');
        this.loadFromGlobal('permissions');
        this.loadFromGlobal('instanceId');
        this.loadFromGlobal('isPublicShare');
    }
    ConfigService.prototype.loadFromGlobal = function (key) {
        // @ts-ignore
        this.values[key] = window['richdocuments_' + key];
    };
    ConfigService.prototype.update = function (key, value) {
        // @ts-ignore
        this.values[key] = value;
    };
    ConfigService.prototype.get = function (key) {
        if (typeof this.values[key] === 'undefined') {
            this.loadFromGlobal(key);
        }
        return this.values[key];
    };
    return ConfigService;
}());
var Config = new ConfigService();
export default Config;
